import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { loginSchema } from '../validation';
import { LoginFormData } from './types';

export const useLoginForm = () => {
  return useForm<LoginFormData>({
    // @ts-expect-error - yup resolver type mismatch with react-hook-form
    resolver: yupResolver(loginSchema),
    mode: 'onChange',
  });
};

export const useLoginState = () => {
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
  return { isLoggingIn, setIsLoggingIn };
};
